export default __webpack_public_path__ + "static/media/0137.a37d383d.png";